$("#remember").click(function () {
  if ($(this).is(":checked")) {
    var username = $('#CustomerEmail').val();
    var password = $('#CustomerPassword').val();
    $.cookie('rusername', username, { expires: 14 });
    $.cookie('rpassword', password, { expires: 14 });
    $.cookie('rremember', true, { expires: 14 });
  } else {
    $.cookie('rusername', null);
    $.cookie('rpassword', null);
    $.cookie('rremember', null);
  }
});
var remember = $.cookie('rremember');
if ( remember == 'true' ) {
  var username = $.cookie('rusername');
  var password = $.cookie('rpassword');
  $('#CustomerEmail').val(username);
  $('#CustomerPassword').val(password);
}
$(function(){
  $('.registerbtn').on('click',function(e) {  
    console.log('click');
    if ($('#RegisterForm-password').val() != $('#RegisterForm-r_password').val()){
      e.preventDefault();
      $('.notmatchpassword').show();      
    }else{      
      $('.notmatchpassword').hide();
      if($('#RegisterForm-email').val() != '' && $('#RegisterForm-password').val() != '' && $('#RegisterForm-r_password').val() != '' && $('#RegisterForm-FirstName').val() != ''  && $('#RegisterForm-LastName').val() != '' && $('#RegisterForm-Country').val() != '' && $('#RegisterForm-DateOfBirth').val() != '' ){
        $('#create_customer').submit();
      }     
    }
  });
});
$(document).on('click','.forgot-button',function(e){
  e.preventDefault();
  $('.login-wrap').hide();
  $('.forgot-wrap').show();
});
$(document).on('click','.enable-login',function(e){
  e.preventDefault();
  $('.login-wrap').show();
  $('.forgot-wrap').hide();
  $('.register_form').removeClass('open_register')
});
$('.account-drawer .another-account a').on('click',function(e){
  e.preventDefault();
  $('.account-tab[data-type="register"]').trigger('click');
});
$('.account-drawer .another-login a').on('click',function(e){
  e.preventDefault();
  $('.account-tab[data-type="sign-in"]').trigger('click');
});
$(document).on('click','.overlay-box',function(e){
  e.preventDefault();
  $('body').removeClass('open-account');
});
$('.account-mob-close').on('click',function(e){
  $('body').removeClass('open-account');
  $('.forgot-wrap').hide();
  $('.login-wrap').show();
  $('.register_form').removeClass('open_register');
});
$('.account-drawer .another-account').on('click',function(e){
  e.preventDefault();
  $('.register_form').addClass('open_register');
  $(".account-drawer").animate({ scrollTop: 0 }, 0);
});
$('.blurdiv-menu').on('click',function(e){
  e.preventDefault();
  $('body').removeClass('open-menu');
});
$(window).on('load',function(e){
  $('.mega-video').each(function(e){
    var mediawrap = $(this).attr('id');
    var videoid = $(this).data('id');
    var player = jwplayer(mediawrap);
    player.setup({playlist: 'https://cdn.jwplayer.com/v2/media/'+videoid,controls: false,repeat:true,autostart: true,mute: true});
  });
});
$(document).on('click', '.lag_curr', function(){
    //$('.outer_drop_down').slideToggle();
  $('body').toggleClass('open_lang');
});
 $('body').on('click',function(e){
    var container = $('.outer_drop_down, .lag_curr');
    if (!container.is(e.target) && container.has(e.target).length === 0){
      //$('.outer_drop_down').slideUp();
      $('body').removeClass('open_lang');
    }
  });
if ($(window).width() <= 991){
  $('.weglot-switch').appendTo('.lng_br .menu_drpdwn').removeClass('d-none');
  $(document).on('click', '.lng_swt', function(){
    $(this).toggleClass('active').parents('.lng_bar').siblings().find('.lng_swt').removeClass('active');
    $(this).parents('.lng_bar').find('.menu_drpdwn').slideToggle().parents('.lng_bar').siblings().find('.menu_drpdwn').slideUp();
  });
  $(window).on('scroll', function(){
    var h_hts = $('.section-header').outerHeight();
    if ($(window).scrollTop() >= h_hts){
      $('body').addClass('sticky_head');
    }
    else{
      $('body').removeClass('sticky_head');
    }
  })
}
else if ($(window).width() >= 992){
  $('.menu_drpdwn .weglot-switch').appendTo('.language_selector').addClass('d-none');
}
$('.shopify-currency-form input').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});
if ($('.annoucement_bar').length > 0 && $('.annoucement_bar').is(':visible')){
    var a_height = $('.annoucement_bar').outerHeight();
}
else{
    var a_height = 0;
}
function desk_search_scroll(){
   var t_height = a_height + $('#shopify-section-header').outerHeight() + $('.mobile-serachbox').outerHeight();
  if ($(window).scrollTop() > 0){
    var t_height = $('#shopify-section-header').outerHeight() + $('.mobile-serachbox').outerHeight();
  }
  $('#predictive-search').height($(window).height() - t_height); 
}
 desk_search_scroll();
function scroll_search(){
 if ($(window).scrollTop() > 0){
  var t_ofs = $('#shopify-section-header').outerHeight();
}
else{
   var t_ofs = a_height + $('#shopify-section-header').outerHeight();
}
 $('.mobile-serachbox').css('top', t_ofs);
}
if($(window).width() <= 991){
  
  $(document).ready(function(){
    if($('.country-selector')){
      var current_lang = $('.country-selector').attr('aria-label').split(':');
      console.log(current_lang[1]);
      $('.lng_br .lng_txt').text(current_lang[1]);
    }
    
  })
  scroll_search(); 
}
  $(window).on('scroll', function(){
    if($(window).width() <= 991){
      scroll_search();
    }
    desk_search_scroll();
  }); 

  $('.mega-list').on('mouseenter', function (e) {
    $('body').addClass('menu_open');
}).on('mouseleave', function (e) {
    $('body').removeClass('menu_open');
 });
 




